import * as React from "react";
import {useState} from "react";
import {Box, Divider, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {useTranslation} from "react-i18next";
import Property from "crqlar-react-common/dist/components/Property";
import {BookingEngine} from "crqlar-react-common/dist/models/bookingEngine/bookingEngine.model";

interface Props {
    bookingEngine: BookingEngine;
    setBookingEngine: (bookingEngine: BookingEngine) => void;
}

const GTM_REGEX = /^GTM-[A-Z0-9]+$/;
const GA4_REGEX = /^G-[A-Z0-9]+$/;

const BookingEngineTrackingTab = ({bookingEngine, setBookingEngine}: Props) => {

    const {t} = useTranslation();

    const [gtmTouched, setGtmTouched] = useState(false);
    const [ga4Touched, setGa4Touched] = useState(false);

    const gtmId = bookingEngine.trackingConfig?.gtmId ?? '';
    const ga4Id = bookingEngine.trackingConfig?.ga4Id ?? '';

    const gtmError = gtmTouched && gtmId.length > 0 && !GTM_REGEX.test(gtmId);
    const ga4Error = ga4Touched && ga4Id.length > 0 && !GA4_REGEX.test(ga4Id);

    const setGtmId = (value: string) => {
        setBookingEngine({
            ...bookingEngine,
            trackingConfig: {
                ...bookingEngine.trackingConfig,
                gtmId: value || undefined,
            },
        });
    };

    const setGa4Id = (value: string) => {
        setBookingEngine({
            ...bookingEngine,
            trackingConfig: {
                ...bookingEngine.trackingConfig,
                ga4Id: value || undefined,
            },
        });
    };

    return (
        <Stack gap={3}>
            <Box>
                <Typography variant="h6" mb={0.5}>
                    {t('Booking Engine Tracking')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {t('Connect your Google Tag Manager and GA4 property to track conversions and user behaviour in the Booking Engine.')}
                </Typography>
            </Box>

            <Divider/>

            <Property title={t('Google Tag Manager ID')}>
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="GTM-XXXXXXX"
                    value={gtmId}
                    onChange={e => setGtmId(e.target.value)}
                    onBlur={() => setGtmTouched(true)}
                    error={gtmError}
                    helperText={gtmError ? t('GTM ID format error') : t('GTM ID helper text')}
                />
            </Property>

            <Property title={t('GA4 Measurement ID')}>
                <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    placeholder="G-XXXXXXXXXX"
                    value={ga4Id}
                    onChange={e => setGa4Id(e.target.value)}
                    onBlur={() => setGa4Touched(true)}
                    error={ga4Error}
                    helperText={ga4Error ? t('GA4 ID format error') : t('GA4 ID helper text')}
                />
            </Property>

        </Stack>
    );
};

export default BookingEngineTrackingTab;
